/* Marketo Customizations */

export function marketo() {

	( ( $ ) => {

		const init = () => {

			// Unstyle all the marketo forms

			// MktoForms2.loadForm( window.COVE.Marketo.marketo_domain, window.COVE.Marketo.munchkin_id, 1622 );
			MktoForms2.whenReady( ( form ) => {
				var formEl = form.getFormElem()[0];

				$( formEl ).find( 'style' ).remove();

				// remove element styles from root and children (may want to disable this while debugging)
				for ( var elsWithStyles = document.querySelectorAll( '#' + formEl.id + ', #' + formEl.id + ' [style]' ), i = 0, imax = elsWithStyles.length; i < imax; i++ ) {
					elsWithStyles[i].removeAttribute( 'style' );
				}

				// disable all Marketo-sourced stylesheets
				for ( var styleSheets = document.styleSheets, i = 0, imax = styleSheets.length; i < imax; i++ ) {
					var ssLoc = document.createElement( 'A' );
					ssLoc.href = styleSheets[i].href;

					if ( ( ssLoc.hostname.search( /\.marketo\.com$/ ) !== -1 ) //  external STYLEs
					||
					( ( styleSheets[i].ownerNode || styleSheets[i].owningElement ).parentNode == formEl ) ) { //  inline STYLEs within FORM tag
						styleSheets[i].disabled = true;
					}
				}

				// add bootstrap classes to the submit buttons
				$( '.modal' )
					.find( '.mktoButton[type="submit"]' )
					.addClass( 'btn' )
					.addClass( 'btn-primary' )
					.addClass( 'text-uppercase' )
					.addClass( 'px-5' )
					.removeClass( 'mktoButton' );

			} );

			// Hide the newsletter subscription form on
			// Form ID: 1622
			MktoForms2.whenReady( ( form ) => {

				if ( 1622 != form.getId() ) {
					return false;
				}

				form.onSuccess( ( values, followUpUrl ) => {
					setTimeout( () => {
						$( 'footer .mktoForm' ).hide();
						$( 'footer .form-success' ).removeClass( 'd-none' );
					} );

					return false;
				});
			});

		}

		init();

	} )( window.jQuery );
}